import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-206996b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = ["width", "height"]
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<filter id=\"dropshadow\" height=\"130%\" data-v-206996b4><feGaussianBlur in=\"SourceAlpha\" stdDeviation=\"1.5\" data-v-206996b4></feGaussianBlur><feOffset dx=\"0\" dy=\"2\" result=\"offsetblur\" data-v-206996b4></feOffset><feComponentTransfer data-v-206996b4><feFuncA type=\"linear\" slope=\"0.5\" data-v-206996b4></feFuncA></feComponentTransfer><feMerge data-v-206996b4><feMergeNode data-v-206996b4></feMergeNode><feMergeNode in=\"SourceGraphic\" data-v-206996b4></feMergeNode></feMerge></filter>", 1)
const _hoisted_4 = ["transform", "r", "cx", "cy", "stroke", "stroke-dasharray", "stroke-dashoffset"]
const _hoisted_5 = ["transform", "r", "cx", "cy", "stroke", "stroke-dasharray", "stroke-dashoffset"]
const _hoisted_6 = ["transform", "r", "cx", "cy", "stroke", "stroke-dasharray", "stroke-dashoffset"]
const _hoisted_7 = ["r", "cx", "cy"]
const _hoisted_8 = ["r", "cx", "cy"]
const _hoisted_9 = ["r", "cx", "cy"]
const _hoisted_10 = ["r", "cx", "cy"]
const _hoisted_11 = {
  key: 4,
  x: "50%",
  y: "53%",
  class: "progress-text",
  "text-anchor": "middle",
  "alignment-baseline": "middle",
  "font-size": "10"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.id,
    class: "radial-progress-container",
    style: _normalizeStyle(_ctx.containerStyle)
  }, [
    (_openBlock(), _createElementBlock("svg", {
      class: "radial-progress-bar",
      width: _ctx.diameter,
      height: _ctx.diameter,
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      _hoisted_3,
      _createElementVNode("circle", {
        transform: 'rotate(' + _ctx.rotation + ', ' + _ctx.radius + ',' + _ctx.radius + ')',
        r: _ctx.innerCircleRadius + 0.8,
        cx: _ctx.radius,
        cy: _ctx.radius,
        fill: "#EFF0F1",
        stroke: _ctx.innerStrokeColor,
        "stroke-dasharray": _ctx.isHideProgress ? _ctx.domainRadius : _ctx.circumference,
        "stroke-dashoffset": _ctx.circumference,
        "stroke-linecap": "round",
        style: _normalizeStyle(_ctx.innerStrokeStyle)
      }, null, 12, _hoisted_4),
      (!_ctx.isHideProgress)
        ? (_openBlock(), _createElementBlock("circle", {
            key: 0,
            transform: 
          'rotate(' + (_ctx.rotation + 6) + ',' + _ctx.radius + ',' + _ctx.radius + ')'
        ,
            r: _ctx.innerCircleRadius + 0.8,
            cx: _ctx.radius,
            cy: _ctx.radius,
            fill: "transparent",
            stroke: _ctx.outerStrokeColor,
            "stroke-dasharray": _ctx.circumference,
            "stroke-dashoffset": _ctx.circumference,
            "stroke-linecap": "square",
            style: _normalizeStyle(_ctx.outerStrokestyle)
          }, null, 12, _hoisted_5))
        : _createCommentVNode("", true),
      (!_ctx.isHideProgress)
        ? (_openBlock(), _createElementBlock("circle", {
            key: 1,
            transform: 'rotate(' + _ctx.rotation + ',' + _ctx.radius + ',' + _ctx.radius + ')',
            r: _ctx.innerCircleRadius + 0.8,
            cx: _ctx.radius,
            cy: _ctx.radius,
            fill: "transparent",
            stroke: _ctx.outerStrokeColor,
            "stroke-dasharray": _ctx.circumference,
            "stroke-dashoffset": _ctx.circumference,
            "stroke-linecap": "round",
            style: _normalizeStyle(_ctx.outerStrokestyle)
          }, null, 12, _hoisted_6))
        : _createCommentVNode("", true),
      _createElementVNode("circle", {
        r: _ctx.innerCircleRadius / 1.11,
        cx: _ctx.radius,
        cy: _ctx.radius,
        fill: "white",
        style: {"filter":"url(#dropshadow)"}
      }, null, 8, _hoisted_7),
      _createElementVNode("circle", {
        r: _ctx.innerCircleRadius / 1.58,
        cx: _ctx.radius,
        cy: _ctx.radius,
        fill: "white",
        style: {"filter":"url(#dropshadow)"}
      }, null, 8, _hoisted_8),
      (_ctx.isHideResponsive)
        ? (_openBlock(), _createElementBlock("circle", {
            key: 2,
            id: "circle3",
            r: _ctx.innerCircleRadius / 2.7,
            cx: _ctx.radius,
            cy: _ctx.radius,
            fill: "white",
            style: {"filter":"url(#dropshadow)"},
            class: "hideCircle-xs"
          }, null, 8, _hoisted_9))
        : (_openBlock(), _createElementBlock("circle", {
            key: 3,
            r: _ctx.innerCircleRadius / 2.7,
            cx: _ctx.radius,
            cy: _ctx.radius,
            fill: "white",
            style: {"filter":"url(#dropshadow)"}
          }, null, 8, _hoisted_10)),
      (!_ctx.isHideProgress)
        ? (_openBlock(), _createElementBlock("text", _hoisted_11, _toDisplayString(Math.round(_ctx.finishedPercentage)) + "% ", 1))
        : _createCommentVNode("", true)
    ], 8, _hoisted_2))
  ], 12, _hoisted_1))
}